import { render, staticRenderFns } from "./VideosBlock.vue?vue&type=template&id=1e24bb7c"
import script from "./VideosBlock.vue?vue&type=script&lang=js"
export * from "./VideosBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports